export default __webpack_public_path__ + "static/media/expl_05_DE.0bdd23ee.png";